// Copyright (c) 2016 Deere & Company

import DemoRentalHistory from '@deere/cps-it.warranty-model-factory/lib/demo-rental-history';
import t from 'tcomb';

const Report = t.list(DemoRentalHistory, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/state/report.js